<template>
  <div>
    <v-app-bar
      color="primary"
      dark
      app
      dense>
      <v-toolbar-title v-text="title" />
      <v-spacer />

      <v-toolbar-items
        icon
        @click.stop="rightDrawer = !rightDrawer">
        <v-btn icon>
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-app-bar>

    <v-navigation-drawer
      v-model="rightDrawer"
      app
      fixed
      right>
      <v-list
        color="primary"
        shaped
        dark>
        <div class="caption mt-5 ml-4 mt-4 mb-2">
          ログインユーザー
        </div>

        <v-list-item>
          <v-list-item-avatar>
            <v-img :src="$store.state.profile.pictureUrl" />
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ $store.state.profile.displayName }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="mt-4" />
        <div class="caption ml-4 mt-4 mb-2">
          選択中のパートナー
        </div>

        <template v-if="$store.state.isSelectWithPartner">
          <v-list-item class="mb-1">
            <v-list-item-avatar>
              <v-img :src="selectPartner.pictureUrl" />
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>{{ selectPartner.displayName }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <template v-else>
          <v-list-item>
            <v-icon class="mr-4">
              {{ soloIcon }}
            </v-icon>
            <v-list-item-content>
              <v-list-item-title>ひとり旅の思い出</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>

      <v-list shaped>
        <v-list-item
          class="mt-1"
          :disabled="$store.state.partners.length <= 0"
          @click="movePartnerChange();">
          <v-badge
            color="red"
            dot>
            <v-icon>
              mdi-account-switch
            </v-icon>
          </v-badge>
          <v-list-item-content class="ml-4">
            <v-list-item-title>パートナー切り替え</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          :disabled="!this.$store.state.profile.userId || this.$store.state.partners.length >= this.$store.state.profile.partnerUpperLimit"
          @click="movePartnerLink();">
          <v-icon>
            mdi-charity
          </v-icon>
          <v-list-item-content class="py-0 ml-4">
            <v-list-item-title>パートナー連携</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          @click="moveTerms();">
          <v-icon class="mr-4">
            mdi-file-document
          </v-icon>
          <v-list-item-title>利用規約</v-list-item-title>
        </v-list-item>

        <v-list-item
          @click="movePrivacy();">
          <v-icon class="mr-4">
            mdi-shield-account
          </v-icon>
          <v-list-item-title>プライバシーポリシー</v-list-item-title>
        </v-list-item>

        <v-list-item
          :disabled="!this.$store.state.profile.userId"
          @click="moveInquiry();">
          <v-icon class="mr-4">
            mdi-message-processing
          </v-icon>
          <v-list-item-title>お問い合わせ</v-list-item-title>
        </v-list-item>

        <v-list-item
          :disabled="!this.$store.state.profile.userId"
          @click="openSettings();">
          <v-icon class="mr-4">
            mdi-settings
          </v-icon>
          <v-list-item-title>設定</v-list-item-title>
        </v-list-item>

        <v-list-item
          :disabled="!this.$store.state.profile.userId"
          @click="logout();">
          <v-icon class="mr-4">
            mdi-exit-to-app
          </v-icon>
          <v-list-item-title>ログアウト</v-list-item-title>
        </v-list-item>
      </v-list>

      <template v-slot:append>
        <div class="text-center mb-5">
          <div class="mb-2 text-size-2">
            <v-icon small>
              mdi-copyright
            </v-icon>
            2019 tty215
          </div>
          <div class="text-size-1">
            Icon made by
            <a
              href="https://www.flaticon.com/authors/freepik"
              target="_blanck">
              Freepik
            </a>
            from
            <a
              href="https://www.flaticon.com/home"
              target="_blanck">
              www.flaticon.com
            </a>
          </div>
        </div>
      </template>
    </v-navigation-drawer>

    <!-- パートナー切り替えボトムシート -->
    <v-bottom-sheet
      v-model="isSwitchPartnerMenu"
      inset>
      <v-list class="pb-5">
        <v-subheader>パートナー切り替え</v-subheader>

        <template v-for="users in $store.state.selectUsers">
          <v-list-item
            :key="users.userId"
            :disabled="$store.state.currentUserId === users.userId"
            @click="changeCurrentUser(users.userId);">
            <v-list-item-avatar>
              <v-img :src="users.pictureUrl" />
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title v-if="users.isPartner">
                {{ users.displayName }}
              </v-list-item-title>
              <v-list-item-title v-else>
                ひとり旅の思い出
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-bottom-sheet>

    <!-- 設定ダイアログ -->
    <v-dialog
      v-model="dialog.setting"
      fullscreen
      persistent
      transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar
          dense
          dark
          color="primary">
          <v-icon class="mr-3">
            mdi-settings
          </v-icon>
          <v-toolbar-title class="mt-1">
            設定
          </v-toolbar-title>
          <v-spacer />
          <v-btn
            icon
            dark
            @click.native="dialog.setting = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <SettingDialog />
      </v-card>
    </v-dialog>

    <!-- パートナー連携ダイアログ -->
    <v-dialog
      v-model="dialog.partner"
      fullscreen
      persistent
      transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar
          dense
          dark
          color="primary">
          <v-icon class="mr-3">
            mdi-charity
          </v-icon>
          <v-toolbar-title class="mt-1">
            ユーザー連携
          </v-toolbar-title>
          <v-spacer />
          <v-btn
            icon
            dark
            @click.native="dialog.partner = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <PartnerLinkDialog :partnerDialog="dialog.partner" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PartnerLinkDialog from '../components/Dialogs/PartnerLinkDialog';
import SettingDialog from '../components/Dialogs/SettingDialog';

import ga from '../libs/ga';
import partnerAccess from '../libs/partnerAccess';

export default {
  components: {
    PartnerLinkDialog,
    SettingDialog,
  },
  data() {
    return {
      title: process.env.VUE_APP_HEADER_TITLE,
      dialog: {
        setting: false,
        partner: false,
        terms: false,
        privacy: false,
      },
      selectPartner: {
        pictureUrl: '',
        displayName: '',
      },
      rightDrawer: false,
      soloIcon: 'mdi-hail',
      isSwitchPartnerMenu: false,
    };
  },
  watch: {
    '$store.state.currentUserId': {
      handler: function () {
        this.selectPartner = this.$store.state.selectUsers.filter(
          user => this.$store.state.currentUserId === user.userId
        )[0];
      },
    },
  },
  created: function() {
    const soloIcons = ['mdi-hiking', 'mdi-hiking', 'mdi-run', 'mdi-human-handsup'];
    this.soloIcon = soloIcons[Math.floor(Math.random() * Math.floor(soloIcons.length))];
  },
  methods: {
    changeCurrentUser: function(userId) {
      this.isSwitchPartnerMenu = false;

      partnerAccess.setCurrentUserId(userId);
      this.$store.commit('updateCurrentUserId', userId);

      this.$router.push('/trip');

      setTimeout(() => {
        this.$store.commit('reloadMemories');
        this.$store.dispatch('showSnackbar', {
          ga: this.$ga,
          snackbar: {
            color: 'info',
            text: 'パートナーを切り替えています...',
            timeout: 2000,
          },
        });
      }, 200);
    },
    movePartnerChange: function() {
      ga.sideMenu.partnerChange(this.$ga);

      this.isSwitchPartnerMenu = true;
      this.rightDrawer = false;
    },
    movePartnerLink: function() {
      ga.sideMenu.partnerLink(this.$ga);

      this.dialog.partner = true;
      this.rightDrawer = false;
    },
    moveTerms: function() {
      ga.sideMenu.terms(this.$ga);

      this.rightDrawer = false;
      this.$router.push('/terms');
    },
    movePrivacy: function() {
      ga.sideMenu.privacy(this.$ga);

      this.rightDrawer = false;
      this.$router.push('/privacy');
    },
    moveInquiry: function() {
      ga.sideMenu.inquiry(this.$ga);

      this.rightDrawer = false;
      this.$router.push('/inquiry');
    },
    openSettings: function() {
      ga.sideMenu.settings(this.$ga);

      this.dialog.setting = true;
      this.rightDrawer = false;
    },
    logout: function() {
      ga.sideMenu.logout(this.$ga);

      document.cookie = 'tripholders-token=; max-age=0';
      this.$router.push('/');
    },
  },
};
</script>
